export default "__VITE_ASSET__CIdW3tIW__"